import { render, staticRenderFns } from "./crm-create-and-column-settings.vue?vue&type=template&id=f58b7502&scoped=true&"
import script from "./crm-create-and-column-settings.vue?vue&type=script&lang=js&"
export * from "./crm-create-and-column-settings.vue?vue&type=script&lang=js&"
import style0 from "./crm-create-and-column-settings.vue?vue&type=style&index=0&id=f58b7502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58b7502",
  null
  
)

export default component.exports